//@vendors
const { createActions } = require('redux-actions');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');

const simpleActions = createActions(
    'LOAN_MODIFY_ASSOCIATED_ACCOUNT',
    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_ERROR',
    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_INACTIVE',
    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_RESET',
    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_SUCCESS',

    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_SET_CURRENT_ACCOUNT',
    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_SET_NEW_ACCOUNT',
    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_SET_VISIBLE_STEP',

    'LOAN_MODIFY_ASSOCIATED_ACCOUNT_VALIDATE_STEP'
);

const postModify = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immLoanModifyAssociatedAccount = getState().loanModifyAssociatedAccount;
        const loanId = immLoanModifyAssociatedAccount.get('loanId');
        const newAccountId = immLoanModifyAssociatedAccount.get('newAccountId');
        const immLoan = getState().loans.getIn(['byId', loanId]);
        const immNewAccount = getState().accounts.getIn(['byId', newAccountId]);
        const requestData = {
            query: {
                dataToken,
                contratoSeleccionado: {
                    numerodecontrato: immLoan.get('contractNumber'),
                    producto: immLoan.get('product')
                },
                nuevoContratoAsociado: {
                    numerodecontrato: immNewAccount.get('contractNumber'),
                    producto: immNewAccount.get('product')
                }
            }
        };

        dispatch(simpleActions.loanModifyAssociatedAccount());
        return APIPost({
            dispatch,
            endpoint: 'loanModifyAssociatedAccountConfirmation',
            params: requestData
        })
            .then((response) => dispatch(simpleActions.loanModifyAssociatedAccountSuccess({ response })))
            .catch((response) => {
                if (!!response.error) {
                    dispatch(simpleActions.loanModifyAssociatedAccountError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}


module.exports = {
    simpleActions,
    postModify
}
